import AtashsooziOmumiBimehNamehDetailSliceType from './AtashsooziOmumiBimehNamehDetailSliceType';

const AtashsooziOmumiBimehNamehDetailInitialState: AtashsooziOmumiBimehNamehDetailSliceType = {
  loading: false,
  data: null,
};

export default AtashsooziOmumiBimehNamehDetailInitialState;
